const actionToState = new Map([
  ['FOLDER_RECEIVE', 'folders'],
  ['DECK_RECEIVE', 'decks'],
  ['SLIDE_RECEIVE', 'slides'],
  ['COMPONENT_RECEIVE', 'component']
]);

export const clearAlerts = store => next => action => {
  if (action && actionToState.has(action.type) && action.payload) {
    const {alerts: {bar: {actionType, check}}} = store.getState();

    if (action && actionType === action.type && action.payload[check[0]] === check[1]) {
      store.dispatch({type: 'ALERT_BAR_HIDE'});
    }
  }

  return next(action);
};
